import { render, staticRenderFns } from "./SelectTemplatePage.vue?vue&type=template&id=8adb6630&"
import script from "./SelectTemplatePage.vue?vue&type=script&lang=js&"
export * from "./SelectTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./SelectTemplatePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports